import {
  RiHashtag,
  RiNewspaperLine,
  RiPulseLine,
  RiRouteLine,
} from 'react-icons/ri'

// One information architecture, shared by the desktop rail and the mobile
// bottom bar. The product is three destinations (Today, Topics,
// Storylines); everything else is a trust
// or marketing page and must not compete with the news for attention.
//
// Naming (2026-09-23): the root is TODAY. The newsletter's web version is a
// secondary page: /edition/latest (the newest sent edition) and
// /edition/[date]. The old "today's paper" at /today was retired on
// 2026-09-28 and redirects to /edition/latest.
export const PRIMARY_NAV = [
  { href: '/', label: 'Today', icon: RiPulseLine },
  // The identity mocks' order (2026-10-31): Storylines before Topics.
  // Topics joined the bar on 2026-10-16 in the slot Sources had.
  { href: '/storylines', label: 'Storylines', icon: RiRouteLine },
  { href: '/topics', label: 'Topics', icon: RiHashtag },
]

// The phone menu's second group (header/Header.jsx, 2026-11-01): everything
// that isn't one of the three destinations, in the order a newcomer asks
// (how does this work, whose reporting is it, then the rest).
export const MENU_MORE = [
  { href: '/how-it-works', label: 'How it works' },
  { href: '/sources', label: 'Sources' },
  { href: '/edition/latest', label: 'Newsletter' },
  { href: '/archive', label: 'Archive' },
  { href: '/about', label: 'About Pano' },
  { href: '/faq', label: 'FAQ' },
  { href: '/contact-us', label: 'Contact us' },
]

// The desktop masthead's nav line (TopBar.jsx, header B, the concept Sam
// approved 2026-11-01): the three destinations, then Sources as the ruler
// the other three are measured with; the About menu after them holds How it
// works and the rest of ABOUT_NAV.
export const TOP_NAV = [...PRIMARY_NAV, { href: '/sources', label: 'Sources' }]

export const SECONDARY_NAV = [
  { href: '/edition/latest', label: 'Newsletter', icon: RiNewspaperLine },
  { href: '/archive', label: 'Archive' },
  { href: '/how-it-works', label: 'How it works' },
  { href: '/about', label: 'About' },
  { href: '/faq', label: 'FAQ' },
  { href: '/contact-us', label: 'Contact' },
]

// The pages about Pano itself, grouped under one "About" menu in the top bar
// and one info button on phones (2026-09-30). They came out of the footer
// and the "New here?" banner: one place, reachable from every page, that
// doesn't compete with the news.
// Ordered the way a newcomer asks (2026-10-16): how does this work, whose
// reporting is it (Sources, moved here from the top bar), who's behind it,
// then the rest.
export const ABOUT_NAV = [
  { href: '/how-it-works', label: 'How it works' },
  { href: '/sources', label: 'Sources' },
  { href: '/about', label: 'About Pano' },
  { href: '/faq', label: 'FAQ' },
  { href: '/contact-us', label: 'Contact us' },
]

// Which destination owns the current path. Story pages now belong to Today:
// with the Edition out of the primary nav, a reader on a story arrived from
// the live feed, and leaving nothing highlighted made the bar look broken.
export function isNavActive(href, pathname) {
  if (href === '/') {
    return pathname === '/' || pathname.startsWith('/news/')
  }
  if (href === '/edition/latest') {
    return pathname.startsWith('/edition')
  }
  if (href === '/storylines') return pathname.startsWith('/storyline')
  if (href === '/topics') return pathname.startsWith('/topic')
  return pathname === href || pathname.startsWith(`${href}/`)
}
